// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__ja-vX","footer":"ReportModalFilter_footer__2DmVU"};